<template>
	<div class="submit-upload">
		<el-upload class="upload-demo" :data="additionalData" :headers="headers" :action="uploadImgUrl" :on-preview="handlePreview" :on-remove="handleRemove" :file-list="fileList" :auto-upload="false">
			<el-button slot="trigger" size="small" type="primary">选取文件</el-button>
			<el-button style="margin-left: 10px" size="small" type="success" @click="submitUpload">上传到服务器</el-button>
			<div slot="tip" class="el-upload__tip" v-if="props.isShowTip">只能上传{{ fileType.join('/') }}文件，且不超过{{ fileSize }}M</div>
		</el-upload>
	</div>
</template>

<script setup>
import { ElMessage, ElMessageBox } from 'element-plus'
import { getToken } from '@/utils/auth'
import { checkFileUpload } from '@/utils/scm'
import { listToString, useImageUrl } from '@/utils/dynamic'
import defaultSettings from '@/settings'

const emit = defineEmits(['update:modelValue'])

const props = defineProps({
	modelValue: [String, Object, Array],
	// 图片数量限制
	limit: {
		type: Number,
		default: 5
	},
	// 大小限制(MB)
	fileSize: {
		type: Number,
		default: 5
	},
	// 文件类型, 例如['png', 'jpg', 'jpeg']
	fileType: {
		type: Array,
		default: () => ['png', 'jpg', 'jpeg', 'gif']
	},
	// 是否显示提示
	isShowTip: {
		type: Boolean,
		default: true
	}
})

const uploadImgUrl = ref(defaultSettings.fileUploadUrl) // 上传的图片服务器地址
const additionalData = ref({
	belongApp: defaultSettings.app,
	belongAppId: defaultSettings.appId
})

const headers = ref({ Authorization: 'Bearer ' + getToken() })

const fileList = ref([])
const modeList = ref([]) //正确的列表

//使用 before-upload 限制用户上传的图片格式和大小
function handleBeforeUpload(file) {
	return checkFileUpload(file, props.fileType, props.fileSize)
}

//上传成功, 数据双向绑定
function handleUploadSuccess(res, files) {
	modeList.value = []
	if (res && res.ResData) {
		//当前上传的临时URL
		let curUrl = files.url
		//当前上传正确的图片信息
		let cname = res.ResData.FileName
		let cicon = res.ResData.FilePath
		//把临时的指替换成正确的指
		fileList.value.forEach((item, index) => {
			let name = item.name
			let url = item.url
			if (item.url == curUrl) {
				name = cname
				url = cicon
			}
			modeList.value.push({ name: name, url: url })
		})
		//更新正确的值用于提交到后端
		emit('update:modelValue', listToString(modeList.value))
	} else {
		ElMessage.error(res.ErrMsg)
	}
}
// 预览
function handlePreview(file) {
	//console.log(file);
}
// 删除图片
function handleRemove(file, files) {
	//console.log(file);
}

//提交上传信息
function submitUpload() {}
// 因为props.modelValue是非引用类型，改变时，需要监听，对响应式数据重新赋值
watch(
	() => props.modelValue,
	(val) => {
		if (val != null && val != '') {
			// 首先将值转为数组
			let list = Array.isArray(val) ? val : val.split(',')
			// 然后将数组转为对象数组
			fileList.value = list.map((item) => {
				if (typeof item === 'string') {
					//显示时加路径
					return { name: item, url: useImageUrl(item) }
				}
			})
		}
	},
	{
		immediate: true,
		deep: true
	}
)
</script>

<style scoped lang="scss">
.submit-upload {
}
</style>
